<div class="filterControls">
    <mat-checkbox *ngIf="hasOfflinePlans" (change)="filterOffline($event.checked)" [labelPosition]="'after'" [checked]="showOfflinePlans" [disabled] ="isDisabled" class="offlineCheckbox">
        Show Offline Plans
    </mat-checkbox>
    <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search...">
    </mat-form-field>
</div>

<table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8" style="table-layout:auto">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)">
            </mat-checkbox>
        </td>
    </ng-container>

    <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->
    <ng-container matColumnDef="renewal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Renewal </th>
        <td mat-cell *matCellDef="let element" id="align-cells"> <mat-icon *ngIf="element.isRenewal">check</mat-icon> </td>
    </ng-container>

    <!-- Carrier Column -->
    <ng-container matColumnDef="carrier">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Carrier </th>
        <td mat-cell *matCellDef="let element"> {{element.carrier.name}} </td>
    </ng-container>

    <!-- PlanName Column -->
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Plan Name </th>
        <td class="link-color" (click)="openPlanModal(element)" mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
    </ng-container>

    <!-- MED/DENT Deductible Column -->
    <ng-container matColumnDef="deductible">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Deductible </th>
        <td mat-cell *matCellDef="let element"> {{element.selectedBenefits['deductible'][0]}} </td>
    </ng-container>

    <!-- MED/DENT Premium Column -->
    <ng-container matColumnDef="premium">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Mo. Quoted Premium </th>
        <td mat-cell *matCellDef="let element"> {{utils.formatCurrency(element.premium)}} </td>
    </ng-container>

    <!-- DENT Maximum Column -->
    <ng-container matColumnDef="maximum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Maximum </th>
        <td mat-cell *matCellDef="let element"> {{element.selectedBenefits['maximum'][0]}} </td>
    </ng-container>

    <ng-container matColumnDef="offline">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-header"> Offline Plan </th>
        <td mat-cell *matCellDef="let element" id="align-cells"> <mat-icon *ngIf="element.isOffline">check</mat-icon> </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
